function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import { utils as utils_exports, AbstractConfigurablePlugin, events as events_exports, AbstractComponent, SYSTEM } from '../core/index.module.js';
import { MathUtils } from '../../three/build/three.module.js';

/*!
 * PhotoSphereViewer.CompassPlugin 5.1.0
 * @copyright 2023 Damien "Mistic" Sorel
 * @licence MIT (https://opensource.org/licenses/MIT)
 */

// src/compass.svg
var compass_default = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="50" cy="50" r="50" fill="rgba(61, 61, 61, .5)"/><path fill="rgba(255, 255, 255, .7)" d="M50 97.1A47 47 0 0 1 32.5 6.5l.8 1.8a45 45 0 1 0 33.4 0l.8-1.8A47 47 0 0 1 50 97Zm0-42a5 5 0 1 1 5-5 5 5 0 0 1-5 5Zm4-41.7h-1.6a.4.4 0 0 1-.4-.2l-4.6-7.7V13a.3.3 0 0 1-.3.3h-1.6a.3.3 0 0 1-.3-.3V1.8a.3.3 0 0 1 .3-.3h1.6a.3.3 0 0 1 .4.2L52 9.4V1.8a.3.3 0 0 1 .3-.3H54c.2 0 .3 0 .3.3V13c0 .2-.1.3-.3.3Z"/></svg>\n';
var HOTSPOT_SIZE_RATIO = 1 / 40;
var CompassComponent = /*#__PURE__*/function (_AbstractComponent) {
  _inherits(CompassComponent, _AbstractComponent);
  var _super = _createSuper(CompassComponent);
  function CompassComponent(viewer, plugin) {
    var _this;
    _classCallCheck(this, CompassComponent);
    _this = _super.call(this, viewer, {});
    _this.plugin = plugin;
    _this.state = {
      visible: true,
      mouse: null,
      mousedown: false,
      markers: []
    };
    _this.background = document.createElement("div");
    _this.canvas = document.createElement("canvas");
    _this.container.appendChild(_this.background);
    _this.container.appendChild(_this.canvas);
    if (_this.config.navigation) {
      _this.container.addEventListener("mouseenter", _assertThisInitialized(_this));
      _this.container.addEventListener("mouseleave", _assertThisInitialized(_this));
      _this.container.addEventListener("mousemove", _assertThisInitialized(_this));
      _this.container.addEventListener("mousedown", _assertThisInitialized(_this));
      _this.container.addEventListener("mouseup", _assertThisInitialized(_this));
      _this.container.addEventListener("touchstart", _assertThisInitialized(_this));
      _this.container.addEventListener("touchmove", _assertThisInitialized(_this));
      _this.container.addEventListener("touchend", _assertThisInitialized(_this));
    }
    _this.applyConfig();
    _this.hide();
    return _this;
  }
  _createClass(CompassComponent, [{
    key: "config",
    get: function get() {
      return this.plugin.config;
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      var _e$changedTouches, _e$changedTouches2;
      switch (e.type) {
        case "mouseenter":
        case "mousemove":
        case "touchmove":
          this.state.mouse = ((_e$changedTouches = e.changedTouches) === null || _e$changedTouches === void 0 ? void 0 : _e$changedTouches[0]) || e;
          if (this.state.mousedown) {
            this.click();
          } else {
            this.update();
          }
          e.stopPropagation();
          e.preventDefault();
          break;
        case "mousedown":
        case "touchstart":
          this.state.mousedown = true;
          e.stopPropagation();
          e.preventDefault();
          break;
        case "mouseup":
        case "touchend":
          this.state.mouse = ((_e$changedTouches2 = e.changedTouches) === null || _e$changedTouches2 === void 0 ? void 0 : _e$changedTouches2[0]) || e;
          this.state.mousedown = false;
          this.click();
          if (e.changedTouches) {
            this.state.mouse = null;
            this.update();
          }
          e.stopPropagation();
          e.preventDefault();
          break;
        case "mouseleave":
          this.state.mouse = null;
          this.state.mousedown = false;
          this.update();
          break;
      }
    }
  }, {
    key: "applyConfig",
    value: function applyConfig() {
      this.container.className = "psv-compass psv-compass--".concat(this.config.position.join("-"));
      this.background.innerHTML = this.config.backgroundSvg;
      this.container.style.width = this.config.size;
      this.container.style.height = this.config.size;
      if (this.config.position[0] === "center") {
        this.container.style.marginTop = "calc(-".concat(this.config.size, " / 2)");
      }
      if (this.config.position[1] === "center") {
        this.container.style.marginLeft = "calc(-".concat(this.config.size, " / 2)");
      }
    }
  }, {
    key: "show",
    value: function show() {
      _get(_getPrototypeOf(CompassComponent.prototype), "show", this).call(this);
      this.update();
    }
  }, {
    key: "setMarkers",
    value: function setMarkers(markers) {
      this.state.markers = markers;
      this.update();
    }
  }, {
    key: "update",
    value: function update() {
      var _this2 = this,
        _this$config$hotspots;
      if (!this.isVisible()) {
        return;
      }
      this.canvas.width = this.container.clientWidth * SYSTEM.pixelRatio;
      this.canvas.height = this.container.clientWidth * SYSTEM.pixelRatio;
      var context = this.canvas.getContext("2d");
      context.clearRect(0, 0, this.canvas.width, this.canvas.height);
      var yaw = this.viewer.getPosition().yaw;
      var fov = MathUtils.degToRad(this.viewer.state.hFov);
      this.__drawCone(context, this.config.coneColor, yaw, fov);
      var mouseAngle = this.__getMouseAngle();
      if (mouseAngle !== null) {
        this.__drawCone(context, this.config.navigationColor, mouseAngle, fov);
      }
      this.state.markers.forEach(function (marker) {
        _this2.__drawMarker(context, marker);
      });
      (_this$config$hotspots = this.config.hotspots) === null || _this$config$hotspots === void 0 ? void 0 : _this$config$hotspots.forEach(function (spot) {
        if ("yaw" in spot && !("pitch" in spot)) {
          spot.pitch = 0;
        }
        var pos = _this2.viewer.dataHelper.cleanPosition(spot);
        _this2.__drawPoint(context, spot.color || _this2.config.hotspotColor, pos.yaw, pos.pitch);
      });
    }
  }, {
    key: "click",
    value: function click() {
      var mouseAngle = this.__getMouseAngle();
      if (mouseAngle !== null) {
        this.viewer.rotate({
          yaw: mouseAngle,
          pitch: 0
        });
      }
    }
  }, {
    key: "__drawCone",
    value: function __drawCone(context, color, yaw, fov) {
      var a1 = yaw - Math.PI / 2 - fov / 2;
      var a2 = a1 + fov;
      var c = this.canvas.width / 2;
      context.beginPath();
      context.moveTo(c, c);
      context.lineTo(c + Math.cos(a1) * c, c + Math.sin(a1) * c);
      context.arc(c, c, c, a1, a2, false);
      context.lineTo(c, c);
      context.fillStyle = color;
      context.fill();
    }
  }, {
    key: "__drawMarker",
    value: function __drawMarker(context, marker) {
      var _this3 = this;
      var color = this.config.hotspotColor;
      if (typeof marker.data["compass"] === "string") {
        color = marker.data["compass"];
      }
      if (marker.isPoly()) {
        context.beginPath();
        marker.definition.forEach(function (_ref, i) {
          var _ref2 = _slicedToArray(_ref, 2),
            yaw = _ref2[0],
            pitch = _ref2[1];
          var a = yaw - Math.PI / 2;
          var d = (pitch + Math.PI / 2) / Math.PI;
          var c = _this3.canvas.width / 2;
          context[i === 0 ? "moveTo" : "lineTo"](c + Math.cos(a) * c * d, c + Math.sin(a) * c * d);
        });
        if (marker.isPolygon()) {
          context.fillStyle = color;
          context.fill();
        } else {
          context.strokeStyle = color;
          context.lineWidth = Math.max(1, this.canvas.width * HOTSPOT_SIZE_RATIO / 2);
          context.stroke();
        }
      } else {
        var pos = marker.state.position;
        this.__drawPoint(context, color, pos.yaw, pos.pitch);
      }
    }
  }, {
    key: "__drawPoint",
    value: function __drawPoint(context, color, yaw, pitch) {
      var a = yaw - Math.PI / 2;
      var d = (pitch + Math.PI / 2) / Math.PI;
      var c = this.canvas.width / 2;
      var r = Math.max(2, this.canvas.width * HOTSPOT_SIZE_RATIO);
      context.beginPath();
      context.ellipse(c + Math.cos(a) * c * d, c + Math.sin(a) * c * d, r, r, 0, 0, Math.PI * 2);
      context.fillStyle = color;
      context.fill();
    }
  }, {
    key: "__getMouseAngle",
    value: function __getMouseAngle() {
      if (!this.state.mouse) {
        return null;
      }
      var boundingRect = this.container.getBoundingClientRect();
      var mouseX = this.state.mouse.clientX - boundingRect.left - boundingRect.width / 2;
      var mouseY = this.state.mouse.clientY - boundingRect.top - boundingRect.width / 2;
      if (Math.sqrt(mouseX * mouseX + mouseY * mouseY) > boundingRect.width / 2) {
        return null;
      }
      return Math.atan2(mouseY, mouseX) + Math.PI / 2;
    }
  }]);
  return CompassComponent;
}(AbstractComponent);

// src/CompassPlugin.ts
var getConfig = utils_exports.getConfigParser({
  size: "120px",
  position: ["top", "left"],
  backgroundSvg: compass_default,
  coneColor: "rgba(255, 255, 255, 0.5)",
  navigation: true,
  navigationColor: "rgba(255, 0, 0, 0.2)",
  hotspots: [],
  hotspotColor: "rgba(0, 0, 0, 0.5)"
}, {
  position: function position(_position, _ref3) {
    var defValue = _ref3.defValue;
    return utils_exports.cleanCssPosition(_position, {
      allowCenter: true,
      cssOrder: true
    }) || defValue;
  }
});
var CompassPlugin = /*#__PURE__*/function (_AbstractConfigurable) {
  _inherits(CompassPlugin, _AbstractConfigurable);
  var _super2 = _createSuper(CompassPlugin);
  function CompassPlugin(viewer, config) {
    var _this4;
    _classCallCheck(this, CompassPlugin);
    _this4 = _super2.call(this, viewer, config);
    _this4.component = new CompassComponent(_this4.viewer, _assertThisInitialized(_this4));
    return _this4;
  }
  _createClass(CompassPlugin, [{
    key: "init",
    value: function init() {
      _get(_getPrototypeOf(CompassPlugin.prototype), "init", this).call(this);
      this.markers = this.viewer.getPlugin("markers");
      this.viewer.addEventListener(events_exports.RenderEvent.type, this);
      this.viewer.addEventListener(events_exports.ReadyEvent.type, this, {
        once: true
      });
      if (this.markers) {
        this.markers.addEventListener("set-markers", this);
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.viewer.removeEventListener(events_exports.RenderEvent.type, this);
      this.viewer.removeEventListener(events_exports.ReadyEvent.type, this);
      if (this.markers) {
        this.markers.removeEventListener("set-markers", this);
      }
      this.component.destroy();
      delete this.markers;
      _get(_getPrototypeOf(CompassPlugin.prototype), "destroy", this).call(this);
    }
  }, {
    key: "setOptions",
    value: function setOptions(options) {
      _get(_getPrototypeOf(CompassPlugin.prototype), "setOptions", this).call(this, options);
      this.component.applyConfig();
      this.component.update();
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      switch (e.type) {
        case events_exports.ReadyEvent.type:
          this.component.show();
          break;
        case events_exports.RenderEvent.type:
          this.component.update();
          break;
        case "set-markers":
          this.component.setMarkers(e.markers.filter(function (m) {
            var _m$data;
            return (_m$data = m.data) === null || _m$data === void 0 ? void 0 : _m$data["compass"];
          }));
          break;
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      this.component.hide();
    }
  }, {
    key: "show",
    value: function show() {
      this.component.show();
    }
  }, {
    key: "setHotspots",
    value: function setHotspots(hotspots) {
      this.config.hotspots = hotspots;
      this.component.update();
    }
  }, {
    key: "clearHotspots",
    value: function clearHotspots() {
      this.setHotspots(null);
    }
  }]);
  return CompassPlugin;
}(AbstractConfigurablePlugin);
CompassPlugin.id = "compass";
CompassPlugin.configParser = getConfig;
CompassPlugin.readonlyOptions = ["navigation"];
export { CompassPlugin };
//# sourceMappingURL=index.module.js.map
